import AuthToggleModal from './authToggleModal'
import AuthToggle from './components' // this is really AuthToggleStepForm

export { AuthToggleModal }
export default AuthToggle
